var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ls-search-form',{ref:"searchForm",attrs:{"formList":_vm.formList},on:{"search":_vm.onSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }